// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
export const counter_RATINGS_PHOTOS = ["%(counter)s fotkou", "%(counter)s fotkami", "%(counter)s fotkami"];
export const STROLLER_ADD_REVIEW = "Pridaj hodnotenie";
